import apiClient from './apiClient';

export function getAccessProfile() {
  return apiClient('/entitlements/me');
}
